// extracted by mini-css-extract-plugin
module.exports = {"tabsRoot":"CategoryWiseSettings_tabsRoot__2z9pN"};